/*
 * @Descripttion: 德运通天然气管理系统
 * @version: 1.0.0
 * @Author: xst
 * @Date: 2020-03-31 13:00:48
 * @LastEditors: xst
 * @LastEditTime: 2020-06-22 16:29:59
 */

import zhLocale from "element-ui/lib/locale/lang/zh-CN";
const cn = {
  routeName: {
    home: "首页",
    shiYan:"实验",
    pointCost: "交割点成本",
    virtualAccount: "客户虚拟户",
    transferVirtual: "虚拟户交易列表",
    discount: "汇票贴现",
    checkDraftApplyPrint: "汇票申请打印",
    beReceiveInvoice: "待收票列表",
    transportEstimate: "运输暂估",
    needPayTax: "应交增值税",
    closingAcount: "关账",
    myReceiveAndPay: "我的应收应付",
    curstomerNeedReceive: "客户应收",
    transportNeedPay: "运输应付",
    supplyNeedPay: "供应商应付",
    transportStand: "运输台账",
    purchaseStand: "采购台账",
    sellStand: "销售台账",
    purchaseEstimate: "采购暂估",
    sellEstimate: "销售暂估",
    purchaseReport: "采购报表",
    transportReport: "运输报表",
    sellReport: "销售报表",
    fundConfig: "财会配置",
    baseConfig: "字典项配置",
    transferAccount: "往来账户",
    cylindermanage:"钢瓶统计",
    transferUnit: "往来单位",
    subject: "会计科目",
    invoiceMag: "财务管理",
    invoiceNew: "发票管理",
    invoiceApply: "发票申领",
    fundMag: "资金管理",
    profitability:"利润分析",
    fixedAssets:"客户资产",
    ratioAnalysis:"成本系数",
    manageRate:"管理费率",
    benefitsList:"利润分析",
    projectBenefits:"项目利润分析",
    tools: "工具箱",
    LNGProposal: "LNG报价单",
    draftCollect: "汇票托收",
    transferOrder: "资金往来",
    payApproveOrder: "付款申请单",
    relateSearch: "相关查询",
    accountBalance: "账户余额",
    receiveMoney: "收款查询",
    payMoney: "付款查询",
    circleStartBalance: "账户期初",
    draft: "承兑汇票",
    performance: "绩效管理",
    performanceRank: "绩效排名",
    performIndex:"考核指标",
    performRule:"考核规则",
    workOrder:"工单列表",
    personPointDetail: "个人绩效",
    decutePointRule: "扣分规则",
    examItemList: "考核项列表",
    appVersion: "app版本管理",
    settlement: "结算管理",
    transport: "运输管理",
    closingAccounts: "销售关账",
    executionClause: "执行条款查询",
    purchaseContract:"采购合同",
    invoice: "开票列表",
    newinvoice: "新建开票",
    beinvoice: "待开票列表",
    metering: "计量结算单",
    otherExpenses: "其他费用列表",
    receivableList:"收款项列表",
    mySettlement: "我的结算单",
    unusualMetering: "异常计量单",
    innerCash:"内部结算",
    purchasePrice:"德运通挂牌价",
    groupPurchase:"集团采购计划",
    innerPrice:"结算单价",
    innerForm:"内部结算",
    compareForm:"结算对比",
    fixedTrack:"固定运费",
    reject:"剔除客户",
    companyPolicy:"公司政策",
    standardFreightList:"基准运费",
    innerPriceHistoryList:'内部挂牌价历史',
    lCngChargeList:'L-CNG充装',
    purchasePriceAnalysis:'采购价分析',
    myPurchase:"采购管理",
    mypurchasel:"我的采购",
    subcompanyPlan:"子公司上报采购计划",
    arrangePurchasingPlan:"总公司安排采购计划",
    batchConfirm:"确认用气计划",
    preferentialClauseList:"优惠条款",
    priceConfirmList:"价格确认函",
    purchaseList:"采购单",
    changeSettleAmountList:"修改结算量",
    purchasePlanH:"采购计划-总",
    newPlan:"新建采购计划",
    purchasePlanL:"用气计划-子",
    newGasPlan:"新建用气计划",
    orders:"采购单管理",
    errororders:"异常采购单",
    checkAmount:"采购对量单",
    purchasePay:"采购付款项",
    purchaseSettle:"采购结算单",
    orderinvoice:"采购收票",
    orderaccount:"采购关账",
    orderform:"采购报表",
    supplierbuget:"供应商预算",
    paybuget:"付款单位预算",
    adjustPrice:"调差管理",
    sell: "销售管理",
    mySell: "我的销售单",
    sellList: "销售单列表",
    changeSupplyWay: "切换供货方式",
    errorSellList: "异常销售单",
    innerCheckList: "销售单核对",
    newSellGaugeTicket: "新建计量单",
    meterReading:"抄表客户列表",
    sellGaugeTicketList: "销售计量单",
    remind: "自定义提醒",
    pending: "我的合同",
    newcontract: "新建合同",
    copyContract: "复制合同",
    checkcontract: "查看合同",
    dailyListing: "每日挂牌",
    dailyCompute: "挂牌价计算器",
    newDaily: "新建挂牌价",
    day: "每日挂牌价",
    imformation: "基础信息",
    companyList: "公司列表",
    organizetion:"组织架构",
    powerSet: "数据权限设置",
    roleList: "角色列表",
    roleAuthorize: "数据角色权限",
    accountList: "账户列表",
    handoverList: "挂牌点列表",
    websiteList: "站点管理",
    gasList:"气源地管理",
    loadList:"装卸地管理",
    staffList: "人员列表",
    myProject: "我的项目",
    projectList: "项目列表",
    myContract: "合同管理",
    contract: "销售合同",
    contractMould: "合同模板",
    newsupply: "新建补充合同",
    adjustmentList: "调价函列表",
    newadjustment: "新建调价函",
    baseset: "基础配置",
    tagList: "标签管理",
    gasificationList: "LNG气化率管理",
    driverList: "驾押员列表",
    carTypeList: "车型列表",
    carSet: "车辆配置",
    ETCList: "ETC列表",
    ETCTradeList: "ETC交易列表",
    fuelCardList: "油卡列表",
    fuelCardTradeList: "油卡交易",
    distanceList:"运输线路",
    otherFeeList: "其他费用",
    gasPriceComputer: "气量单价计算器",
    carTransportReport: "车辆运输统计",
    twoInvoiceTransportReport: "两票制运费查询",
    transportCheckReport: "运输单核查",
    errorTransportList: "异常运输单",
    gasPriceList: "气量运输单价",
    oilPriceList: "运输油价",
    loadUnloadList: "装卸单列表",
    familyFeeList: "车辆家次费",
    transportContractList: "运输合同",
    myTransport: "我的运输单",
    taskList: "任务单列表",
    transportCheckList: "运输单核对",
    transportList: "运输单列表",
    newTransport: "新建运输单",
    newTrance:"新建集装格任务单",
    checkAmountList: "运输对量单",
    checkMoneyList: "运输结算单",
    transportPay:"运输付款项",
    tollList:"通行费用管理",
    saturation:"运输饱和度",
    compareData: "异常单据对比",
    publishArticle: "发表文章",
    publishArticleEditor: "发表文章-富文本",
    icon: "图标",
    builtInIcon: "内置图标",
    shuttleBox: "穿梭框",
    demoShuttle: "穿梭框demo",
    permissions: "权限管理",
    pageControl: "页面权限",
    btnControl: "按钮权限",
    table: "表格",
    multiDataTable: "多选数据表格",
    filterTable: "筛选表格",
    dragSort: "拖拽排序",
    upload: "上传",
    fileUpload: "文件上传",
    editor: "编辑器",
    markdown: "markdown",
    wangeditor: "wangeditor",
    multiDirectory: "多级目录",
    "menu2-1": "二级-1",
    "menu2-2": "二级-2",
    "menu2-3": "二级-3",
    "menu3-1": "三级-1",
    "menu3-2": "三级-2",
    "menu3-3": "三级-3",
    "menu4-1": "四级-1",
    "menu4-2": "四级-2",
    "menu5-1": "五级-1",
    systemSettings: "系统设置",
    navMenu: "导航菜单",
    /*贸易 start*/
    riskControl:'风控看板',
    trade:'贸易管理',
    collectionList:'实时应收',
    tradeRuleList:'贸易规则',
    tradeCustomerList:'贸易客户',
    myTrade:'我的贸易',
    tradeContractList:'贸易合同管理',
    priceConfirm:'价格确认函',
    tradeDemand:'贸易需求单',
    tradeSale:'贸易销售单',
    tradeCollection:'贸易收款项',
    tradeCheckAmount:'贸易对量单',
    tradeSettle:'贸易结算单',
    tradeContract:'贸易合同',
    tradeProfit:'利润分配',
    profitStatistics:'利润统计',
    profitRule:'利润规则',
    customerRebate:'客户返利',
    businessBx:'业务费用报销',
    rewardRuleList:'销售员奖励规则',
    awardIssueRuleList:'奖励发放规则',
    staffRoleList:'员工角色列表',
    salesRewardDetailList:'销售员奖励明细',
    otherRewardDetailList:'其他人员明细',
    awardIssueDetailList:'奖励发放明细',
    newBattlePlan:'2021决战录入',
    statisticsPlan:'本年度分解计划表',
    gasUseAndPrice:'储罐存量配置',
    lngInOutBase:'LNG出入库 ',

    /*贸易 end*/
    /*钢瓶管理 start*/
    cylinder:'钢瓶管理',
    scanRecord:'集装格扫描记录',
    cylinderTagList:'射频标签',
    cylinderList:'钢瓶列表',
    cylinderContainer:'集装格',
    truckRecord:'车辆扫描记录',
    /*钢瓶管理 end*/
    /*new 合同首頁 start*/
    contractIndex:'我的合同',
    /*new 合同首頁 end*/

    charge:'充装管理',
    chargeList:'充装单列表',
    checkChargeList:'充装单核对列表',

    /*统计报表 start*/
    statics:'统计报表',
    weeklyCollectionStaticsList:'应收账目周统计',
    cngReport:'CNG生产周报',
    lngReport:'LNG生产周报',
    /*统计报表 end*/

    /*其他业务 start*/
    otherBusiness:'其他业务',
    circulationList:'流转业务',
    circulationAdd:'新增流转单',
    specialProcessPurchaseList:'非标业务',
    /*其他业务 end*/
    oweApplyList:'欠费申请',
    siteVisit: "站点访问统计",
    /*工资管理 start*/
    salaryManagement:"工资管理",
    individualIncomeTaxLevel:"个税等级",
    floatingSalaryType:"浮动工资类型",
    socialSecurityInformation:"社保信息",
    personnelSalaryInformation:"人员工资信息",
    floatingSalary:"浮动工资",
    salaryDetails:"工资明细",
    salaryAdjustment:"工资调差",
    salarySummary:"工资汇总",
    attendanceSummary:"考勤汇总",
    /*工资管理 end*/

    /*报销管理 start*/
    reimburse:'报销管理',
    reimburseManagement:'报销单',
    reimbursementSummary:'报销汇总',
    reimbursementType:'报销类型',
    indexStaff:'报销单填报',
    reimbursementStatistics:'报销统计',
    /*报销管理 end*/
    /*气款管理 start*/
    gasManagement:'气款管理',
    gasPaymentApplication:'气款申请单',
    estimatedCost:'预算费用',
    /*气款管理 end*/

    /*绩效考核 start*/
    performanceAppraisal:'绩效考核',
    levelConfiguration:'等级配置',
    assessmentCoefficient:'考核系数',
    assessmentItems:'考核项目',
    assessmentRole:'考核角色',
    assessmentObject:'考核对象',
    examinationTableMonth:'月度考核表',
    examinationTableYear:'年度考核表',
    monthlyTaskDashboard:'月度任务看板',
    annualTaskDashboard:'年度任务看板',
    performanceStatistics:'绩效统计',
    assessmentDataInput:'考核数据录入',
    /*绩效考核 start*/

  },
  rightMenu: {
    close: "关闭",
    closeOther: "关闭其他",
    closeAll: "全部关闭"
  },
  role: {
    superAdmin: "超级管理员",
    admin: "管理员",
    ordinary: "普通用户"
  },
  userDropdownMenu: {
    basicInfor: "基本资料",
    changePassword: "修改密码",
    logout: "退出"
  },

  ...zhLocale //  合并element-ui内置翻译
};

export default cn;



// WEBPACK FOOTER //
// ./src/i18n/lang/cn.js